export default __webpack_public_path__ + "static/media/Raleway-Thin.537e4a26.ttf";